import React, { useEffect, useState } from 'react';
import { faLeftLong, faRightLong } from '@fortawesome/free-solid-svg-icons';
import { Section, MainTitle } from '../Styled';
import Card from './Card';
import {
  ArrowCon,
  SliderArrow,
  SliderSection,
  SliderSelf,
  SliderWrap,
} from './Slider.styled';


const Slider = ({ CARDS }) => {
  const [currentIndex, setCurrentIndex] = useState(2);
  const [length, setLength] = useState(CARDS.length);

  useEffect(() => {
    setLength(CARDS.length - 1);
  }, [CARDS.length]);

  const next = () => {
    if (currentIndex < length) {
      setCurrentIndex(prevState => prevState + 1);
    }
    if (currentIndex < 0) {
      setCurrentIndex(prevState => prevState - 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1);
    }
    if (currentIndex < 0) {
      setCurrentIndex(prevState => prevState + 1);
    }
  };

  return (
    <div>
      <Section>
        <MainTitle>Hvorfor vælge Noaly?</MainTitle>
      </Section>
      <SliderSection>
        <SliderWrap>
          <SliderSelf
            style={{ transform: `translateX(-${currentIndex * 300}px)` }}
          >
            {CARDS.map(kort => (
              <Card
                key={kort.id}
                id={kort.id}
                title={kort.title}
                text={kort.text}
                source={kort.source}
                currentIndex={currentIndex}
              />
            ))}
          </SliderSelf>
        </SliderWrap>
        <ArrowCon>
          <SliderArrow icon={faLeftLong} onClick={prev} />
          <SliderArrow icon={faRightLong} onClick={next} />
        </ArrowCon>
      </SliderSection>
    </div>
  );
};

export default Slider;
